import { Injectable, signal } from "@angular/core";
import { Menu } from "../components/menu/menu.model";
import { verticalMenuItems } from "../components/menu/menu";
import { AuthenticationService } from "../../shared/services/authentication/authentication.service";
import { ConfigService } from "../../shared/services/config/config.service";
import { MENU_ROLE_ACCESS_MAP } from "../../../../public/assets/config/constants";

const menuRoleAccessMap: Record<number, string[]> = MENU_ROLE_ACCESS_MAP;

// Menu IDs that should only be visible in non-production environments
const NON_PRODUCTION_ONLY_MENU_IDS = [31]; // DB Sync
 

@Injectable({
  providedIn: "root",
})
export class MenuService {
  isMenuCollapsed = signal<boolean>(false);
  userRoles: string[] = [];
  drawerOpened = signal<boolean>(true);
  
  

  constructor(
    private authenticationService: AuthenticationService,
    private configService: ConfigService
  ) {}

  getVerticalMenuItems(): Menu[] {
    this.userRoles = this.authenticationService.getUserRoles();
    let filteredMenu = this.filterMenuItemsByRole(
      verticalMenuItems,
      this.userRoles
    );
    // Filter out non-production only menus if in production
    const isProduction = this.configService.getConfigProperty('production');
    if (isProduction) {
      filteredMenu = filteredMenu.filter(item => !NON_PRODUCTION_ONLY_MENU_IDS.includes(item.id));
    }
    return filteredMenu;
  }

  private filterMenuItemsByRole(
    menuItems: Menu[],
    userRoles: string[]
  ): Menu[] {
    return menuItems.filter((item) => {
      // Check if menu item has role restrictions defined
      const allowedRoles = menuRoleAccessMap[item.id] || menuRoleAccessMap[item.parentId];
      
      // If no roles are defined for this menu item, deny access by default
      if (allowedRoles === undefined) {
        return false;
      }
      
      // If empty array, it means accessible to all roles (like Home)
      if (allowedRoles.length === 0) {
        return true;
      }
      
      // Check if user has any of the allowed roles
      return allowedRoles.some(role => userRoles.includes(role));
    });
  }

  updateMenuCollapsed(isCollapsed: boolean) {
    this.isMenuCollapsed.set(isCollapsed);
  }

  toggleMenuItem(menuId: number): void {
    const menuItem = document.getElementById(`menu-item-${menuId}`);
    const subMenu = document.getElementById(`sub-menu-${menuId}`);
    if (!subMenu) {
      return;
    }
    subMenu.classList.toggle("show");
    menuItem?.classList.toggle("expanded");
  }

  closeOtherSubMenus(menu: Menu[], menuId: number): void {
    const currentMenuItem = menu.find((item) => item.id === menuId);
    if (
      !currentMenuItem ||
      currentMenuItem.parentId !== 0 ||
      currentMenuItem.target
    ) {
      return;
    }
    menu.forEach((item) => {
      if (item.id !== menuId) {
        const subMenu = document.getElementById(`sub-menu-${item.id}`);
        const menuItem = document.getElementById(`menu-item-${item.id}`);
        if (subMenu?.classList.contains("show")) {
          subMenu.classList.remove("show");
          menuItem?.classList.remove("expanded");
        }
      }
    });
  }

  openDrawer() { this.drawerOpened.set(true); }
  closeDrawer() { this.drawerOpened.set(false); }
  toggleDrawer() { this.drawerOpened.update(v => !v); }
}
